module.exports = __webpack_public_path__ + "img/arrow.7c0aa8ba.svg";